export function getUrlParams() {
    let params = {};
    let search = location.search.substring(1);
    if (search){
        params = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}', function(key, value) { return key===""?value:decodeURIComponent(value) })
    }
    return params;
}

export function getUrlPathname() {
    let url =  window.location.pathname;
    return url;
}
